module.exports = __webpack_public_path__ + "static/media/ht-new.27463439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/ht-new.jpg
// module id = 234
// module chunks = 0